import {Box} from '@mui/material';
import React, {useEffect} from 'react';
import styles from './header.module.scss';
import { FormattedMessage } from 'react-intl';
import {setIndicatorLoading} from '../../../features/indicator';

interface Props{
    headerLocalizationId?: string;
    children?: any;
    textStyle?: React.CSSProperties;
    loading?: boolean;
}
export default function Header(props: Props) {
    useEffect(() => {
        setIndicatorLoading(props.loading ?? false);

        return () => {
            setIndicatorLoading(false);
        };
    }, [props.loading]);
    
    return (<Box className={styles.container}>
        <div className={styles.firstPart}>
            <span style={props.textStyle}>
                {props.headerLocalizationId ? <FormattedMessage id={props.headerLocalizationId} /> : <></>}
                {props.children ? ':' : ''}
            </span>
        </div>
        {props.children && (
            <div className={styles.secondPart}>
                {props.children}
            </div>
        )}
    </Box>)
}
